import { applyTokens } from "../../../utilities/applyTokens.js";
export const badgePresets = (tokens) => {
    const { badge } = tokens.component;
    return {
        size: {
            sm: {
                sx: {
                    ".MuiBadge-badge": Object.assign(Object.assign({}, applyTokens(badge.counter.small)), applyTokens(badge.counter.small.label)),
                },
            },
        },
    };
};
//# sourceMappingURL=badge.js.map